"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ShareInput = _interopRequireDefault(require("../../decorators/ShareInput"));

var _UISearchInput = _interopRequireDefault(require("../../input/UISearchInput"));

var _component = _interopRequireDefault(require("../../utils/propTypes/component"));

var UITypeaheadSearch =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITypeaheadSearch, _PureComponent);

  function UITypeaheadSearch() {
    (0, _classCallCheck2.default)(this, UITypeaheadSearch);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITypeaheadSearch).apply(this, arguments));
  }

  (0, _createClass2.default)(UITypeaheadSearch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaControls = _this$props['aria-controls'],
          className = _this$props.className,
          Input = _this$props.Input,
          style = _this$props.style,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["aria-controls", "className", "Input", "style"]);
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('private-search-control__wrapper', className),
        style: style
      }, _react.default.createElement(Input, (0, _extends2.default)({
        "aria-autocomplete": "list",
        "aria-controls": ariaControls
      }, rest)));
    }
  }]);
  return UITypeaheadSearch;
}(_react.PureComponent);

UITypeaheadSearch.propTypes = {
  'aria-controls': _propTypes.default.string,
  Input: _component.default.isRequired
};
UITypeaheadSearch.defaultProps = {
  Input: _UISearchInput.default
};
UITypeaheadSearch.displayName = 'UITypeaheadSearch';

var _default = (0, _ShareInput.default)(UITypeaheadSearch);

exports.default = _default;
module.exports = exports.default;